module.exports = __webpack_public_path__ + "static/npc_lucas@4x-26a96bd535c914b23c296a714c8f7937.png";